<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="单号" prop="oddNo">
                      <el-input v-model="queryCondition.oddNo" clearable style="width:100%"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="评价期" prop="appraisePeriod">
                    <el-select v-model="queryCondition.appraisePeriod" clearable  filterable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in allDate" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code"  clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                      <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="Farm Group" prop="farmGroup">
                      <el-input v-model="queryCondition.farmGroup" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="等级" prop="grande">
                        <el-select v-model="queryCondition.grande" clearable  filterable placeholder="请选择" style="width:100%">
                            <el-option :key="index" v-for="(item,index) in gradeList" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="queryCondition.status" clearable  filterable placeholder="请选择" style="width:100%">
                            <el-option :key="index" v-for="(item,index) in statusList" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button  size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button  v-acl="RMC_PROD_SCORE_APPROVE" class="btn" type="primary" @click="approve">批准</el-button>
        <el-button  v-acl="RMC_PROD_SCORE_RETURN" class="btn" type="primary" @click="rejectBatch">退回</el-button>
        <el-dropdown v-acl="RMC_PROD_SCORE_EXPORT" split-button type="primary" @click="handleClick" placement="bottom" style="margin-right: 10px;">
          报表导出
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button size="mini" class="dropdownItemBtn" type="primary" @click="exportData">评分报表</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button size="mini" class="dropdownItemBtn"  type="primary" @click="exportFactsData">评分报表(Facts)</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="单号" min-width="140" field="oddNo">
            <template v-slot="scope">
                <el-button type="text" @click="openDetail(scope.row)">{{scope.row.oddNo}}</el-button>
            </template>
        </ux-table-column>
        <ux-table-column align="center" title="评价期" min-width="100" field="appraisePeriod"></ux-table-column>
        <ux-table-column align="center" title="Category3" field="category3Name"  width="100" />
        <ux-table-column align="center" title="Sponsor" min-width="100" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="Farm Group" min-width="140" field="farmGroup"></ux-table-column>
        <ux-table-column align="center" title="等级" min-width="85" field="scoreGrade1"></ux-table-column>
        <ux-table-column align="center" title="状态" min-width="100" field="statusView"></ux-table-column>
        <ux-table-column align="center" title="更新人" min-width="100" field="updateByName"></ux-table-column>
        <ux-table-column align="center" title="更新时间" min-width="120" field="updateDate"></ux-table-column>
        <ux-table-column align="center" title="操作" min-width="100" field="createDate">
            <template v-slot="scope">
                <el-button type="text" @click="openDetail(scope.row)">评分</el-button>
            </template>
        </ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    
    <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <div slot="title" class="header-title">
            <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
                <p class="line"></p>
                <p class="info_title">ASL关联数据查看</p>
            </div>
        </div>
        <ux-grid v-if="dialogVisible" ref="plxTable" :data="tableData" max-height="500" show-overflow="tooltip" highlight-current-row>
            <ux-table-column align="center" title="关联数据" min-width="100" field="category2Name"></ux-table-column>
            <ux-table-column align="center" title="已有数据" min-width="100" field="category2Name"></ux-table-column>
            <ux-table-column align="center" title="操作" min-width="100" field="category2Name">
                <template v-slot="scope">
                    <el-button type="text" >查看</el-button>
                </template>
            </ux-table-column>
        </ux-grid>
    </el-dialog>



    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import aslApi from "@/api/rmcProtein/asl"; 
import commonFunction from "@/utils/dataTableUtils";
import updateDialog from '@/components/page/RMC/Protein/rmcDrugList/updateDialog'
import QBRApi from "@/api/QBR/index";
import rmcGrade from '@/api/rmcProduce/rmcGrade';
import rmcProdFarmApi from "@/api/rmcProduce/farm";
import proteinDrug from "@/api/rmcProtein/drug";
import { fileService } from "@/api/common/file-utils";


export default {
  name: '',
  components: {
    updateDialog,
    // detailDialog
  },
  data() {
    return {
      identity:localStorage.getItem('ms_emplFlag'),
      dialogVisible:false,
      multipleSelection:[],
      domesticOrOverseas:[],
      category3List:[],
      statusList: [],
      queryCondition: {
        appraisePeriod:"",
        aslName:"",
        category3Code:"10301",
        domesticOrOverseas:"",
        grande:"",
        oddNo:"",
        sponsorName:"",
        status:"",
        pageNum: 1,
        pageSize: 15,
      },
      isShow: false,
      tableData: [],
      totalCount:"",
      allDate:[],
      gradeList:[],
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   to.meta.reqData={}
  //   if (from.path === '/qspiTodo' ) {
  //     if(to.query.appraisePeriod){
  //       to.meta.reqData.appraisePeriod = to.query.appraisePeriod
  //     }
  //     if(to.meta.reqData.sponsorName ){
  //       to.meta.reqData.sponsorName = to.query.sponsorName
  //     }
  //     rmcGrade.getdPageList(to.meta.reqData).then((res) => {
  //       next(vm => {
  //         vm.queryCondition = to.meta.reqData;
  //         vm.tableData = res.resultData;
  //         vm.totalCount = res.totalCount;
  //       })
  //     })
  //   }
  //   next()
  // },
  destroyed(){
    this.$store.dispatch('saveQueryData',{})
  },
  created() {
    let queryData=this.$store.state.asl.skipQuery
    // if(queryData.sponsorName){
    //   this.$set(this.queryCondition,'sponsorName',queryData.sponsorName)
    // }
    // if(queryData.aslName){
    //   this.$set(this.queryCondition,'aslName',queryData.aslName)
    // }
    // if(queryData.domesticOrOverseas){
    //   this.$set(this.queryCondition,'domesticOrOverseas',queryData.domesticOrOverseas)
    // }
    // if(queryData.category3Code){
    //   this.$set(this.queryCondition,'category3Code',queryData.category3Code)
    // }
    if(queryData.farmGroup){
      this.$set(this.queryCondition,'category3Code','')
      this.$set(this.queryCondition,'appraisePeriod','')
      this.$set(this.queryCondition,'farmGroup',queryData.farmGroup)
    }
    this.getStatusList()
    this.getGradeList()
    this.getAllDate()
    this.getCategory3Lists()
  },
  methods: {
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      rmcGrade.getdPageList(this.queryCondition).then((res)=>{
        this.tableData=res.resultData
        this.totalCount=res.totalCount
      })
    },
    onGrade(row){
      sessionStorage.setItem("taskDetail",JSON.stringify(row))
      this.$router.push({
          path:"/rmcDrugDosage/detail",
          query:{

          }
      })
    },
    onReset() {
      this.queryCondition={
        appraisePeriod:"",
        aslName:"",
        category3Code:"10301",
        domesticOrOverseas:"",
        grande:"",
        oddNo:"",
        sponsorName:"",
        status:"",
        pageNum: 1,
        pageSize: 15,
      }
      let defaultVal=this.allDate.filter((a)=>{return a.isDefault})
      if(defaultVal.length>0){
        this.queryCondition.appraisePeriod=defaultVal[0].code
      }
      this.queryData();
    },
    addList() {
      this.$router.push({
          path:"/rmcProtASL/detail",
          query:{

          }
      })
    },
    openDetail(row){
        this.$router.push({
            path:"/rmcProdScore/detail",
            query:{
                id:row.ttRmcProduceScoreId
            }
        })
    },
    pageSizeChange(val){
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val){
      this.queryCondition.pageNum = val
      this.queryData()
    },
    exportData(){
        let ids=[]
        this.multipleSelection.forEach((v)=>{
          ids.push(v.ttRmcProduceScoreId)
        })
        this.queryCondition.selectedIdList=ids
        rmcGrade.exportProteinScore(this.queryCondition).then((res)=>{
          fileService.resNameToFile(res);
        })
    },
    exportFactsData(){
        let ids=[]
        this.multipleSelection.forEach((v)=>{
          ids.push(v.ttRmcProduceScoreId)
        })
        this.queryCondition.selectedIdList=ids
      rmcGrade.exportProteinScoreHasFacts(this.queryCondition).then((res)=>{
          fileService.resNameToFile(res);
      })
    },
    selectionChange(val){
      this.multipleSelection=val
    },
    handleClose(){
      this.dialogVisible=false
      this.queryData()
    },
    approve(){
      if(this.multipleSelection.length==0){
        this.$message.error('请至少勾选一条数据')
      }else{
        let arr=[]
        this.multipleSelection.forEach((v)=>{
          arr.push(v.ttRmcProduceScoreId)
        })
        rmcGrade.approvalBatch(arr).then((res)=>{
          if(res.code==200){
            this.$message.success('批准成功')
            this.queryData()
          }else{
            this.$message.error(res.msg)
          }
        })
      }
    },
    rejectBatch(){
      if(this.multipleSelection.length==0){
        this.$message.error('请至少勾选一条数据')
      }else{
        let isCreate=this.multipleSelection.some((v)=>{
          return v.status!=2
        })
        if(isCreate){
          this.$message.error('只有已提交状态可退回')
        }else{
          this.$prompt('', '请填写退回意见', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValidator: (value) => {  
              if(!value) {
                return '退回意见不能为空！';
              }
            },
          }).then(({ value }) => {
            let params={
              idList:[],
              rejectReason:value
            }
            this.multipleSelection.forEach((v)=>{
              params.idList.push(v.ttRmcProduceScoreId)
            })
            rmcGrade.rejectBatch(params).then((res)=>{
              if(res.code==200){
                this.$message.success('退回成功')
                this.queryData()
              }else{
                this.$message.error(res.msg)
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });       
          });
        }
        
      }
      
    },
    examine(row){
        console.log("sssss",row)
        this.$router.push({
            path:"/rmcProdScore/detail",
            query:{

            }
        })
    },
    getCategory3Lists() {
      rmcProdFarmApi.getSelection(['rmc.RmcCategory3']).then((res)=>{
       if(res.code==200){
          this.category3List=res.data['rmc.RmcCategory3'].filter((v)=>{
            return v.cascadeKey=='produce'
          })
        }else{
          this.$message.error(res.msg)
        }
        console.log("获取的列表====",res)
      })
    },
    getAllDate(){
      rmcGrade.getAllDate().then((res)=>{
        let defaultVal=res.resultData.filter((a)=>{return a.isDefault})
        let queryData=this.$store.state.asl.skipQuery

        if(defaultVal.length>0){
          this.$set(this.queryCondition,'appraisePeriod',defaultVal[0].code)
        }
        if(this.$route.query.appraisePeriod){
          this.$set(this.queryCondition,'appraisePeriod',this.$route.query.appraisePeriod)
        }
        if(this.$route.query.sponsorName){
          this.$set(this.queryCondition,'sponsorName',this.$route.query.sponsorName)
        }
        if(this.$route.query.status){
          this.$set(this.queryCondition,'status',this.$route.query.status)
        }
        if(queryData.farmGroup){
          this.$set(this.queryCondition,'appraisePeriod','')
        }
        this.queryData();
        this.allDate=res.resultData
      })
    },
    getGradeList(){
      rmcGrade.getGradeDictionList().then((res)=>{
        this.gradeList=res.resultData
      })
    },
    getStatusList(){
      rmcGrade.getStatusList().then((res)=>{
        this.statusList=res.resultData
      })
    }
    
  },
  extends: commonFunction
}
</script>
<style scoped >
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
